<div class="centreMiddle divCenterBoxItems w-100">
    <div class="panelBase">
        <div class="panelHeader">Download File</div>
        <div class="panelDownload">
            <button type="button" class="btn btn-download btn-download-display" (click)="onDownloadClick()">Click Here to download your file</button>
        </div>
    </div>
</div>